module.exports = __webpack_public_path__ + "img/fedding3.e2c8530f.png";